import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import NotificationList from './NotificationList';

export default function NotificationsPage() {
  const { theme } = useTheme();
  const navigate = useNavigate();

  const handleNotificationClick = (notification) => {
    if (notification.actionUrl) {
      navigate(notification.actionUrl);
    }
  };

  // Close returns where they came from, falling back to the feed when this was
  // opened directly — a bare navigate(-1) on a fresh tab leaves the app.
  const handleClose = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate('/');
  };

  return (
    <div className={`min-h-screen ${theme.background}`}>
      <div className="max-w-2xl mx-auto px-4 py-8">
        <NotificationList onNotificationClick={handleNotificationClick} onClose={handleClose} />
      </div>
    </div>
  );
}
